'use client';

import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { AccountOrder } from '../types';
import { PRESETS } from 'src/utils/formatNumber/presets';

interface FilledCellProps {
	order: AccountOrder;
	showAccountValues: boolean;
}

export function FilledCell({ order, showAccountValues }: FilledCellProps) {
	return (
		<NumberDisplay
			value={order.baseAssetAmountFilled}
			options={PRESETS.tradePrecisionTrim}
			isAccountValueToHide={!showAccountValues}
		/>
	);
}
